import { Download, X } from "lucide-react";
import { useState } from "react";
import useAppUpdate from "../hooks/useAppUpdate";

export default function UpdateBanner() {
  const { updateReady, applyUpdate } = useAppUpdate();
  const [dismissed, setDismissed] = useState(false);

  if (!updateReady || dismissed) return null;

  return (
    <div
      data-testid="update-banner"
      className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:max-w-sm z-[300] rounded-xl border-2 border-[#FF6B00] bg-[#141210] shadow-[0_12px_40px_rgba(0,0,0,0.6),0_0_28px_rgba(255,107,0,0.35)] overflow-hidden animate-in slide-in-from-bottom"
      role="status"
      aria-live="polite"
    >
      <div className="flex items-start gap-3 p-4">
        <span className="shrink-0 inline-flex items-center justify-center w-10 h-10 rounded-full bg-[#FF6B00]/15 border border-[#FF6B00]/40 text-[#FF6B00]">
          <Download size={18} />
        </span>
        <div className="min-w-0 flex-1">
          <p className="font-anton uppercase text-base text-[#F5F2EB] leading-tight">
            Nuova versione disponibile
          </p>
          <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-[#A39A8F] mt-1">
            Aggiorna per vedere le ultime novità
          </p>
          <div className="mt-3 flex items-center gap-2">
            <button
              type="button"
              data-testid="update-apply"
              onClick={applyUpdate}
              className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md border-2 border-[#FF6B00] bg-[#FF6B00] text-[#12100e] hover:bg-[#ff8226] active:scale-95 transition font-mono text-[10px] uppercase tracking-[0.22em] font-semibold"
            >
              Aggiorna ora
            </button>
            <button
              type="button"
              data-testid="update-dismiss"
              onClick={() => setDismissed(true)}
              className="inline-flex items-center px-2 py-1.5 rounded-md border border-[#332f2b] text-[#A39A8F] hover:text-[#F5F2EB] transition font-mono text-[10px] uppercase tracking-[0.22em]"
            >
              Dopo
            </button>
          </div>
        </div>
        <button
          type="button"
          onClick={() => setDismissed(true)}
          aria-label="Chiudi"
          className="shrink-0 -mt-1 -mr-1 p-1 text-[#69635c] hover:text-[#F5F2EB] transition"
        >
          <X size={14} />
        </button>
      </div>
    </div>
  );
}
